import _ from 'lodash';
import { action, computed, observable } from 'mobx';
import { ListApplicationSettings } from 'src/stores/SettingsStores/SettingsPageStore/ListApplicationSettings';
import { SettingsScoringModelStore } from 'src/stores/SettingsStores/SettingsScoringModelStore/SettingsScoringModelStore';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';

export type SettingsPageFilter = {
    search?: string;
};

export type ApplicationSettingItem = typeof ListApplicationSettings[0];

export class SettingsPageStoreClass extends BasicStore<ApplicationSettingItem> {
    itemDetailsFormKey = '';

    itemEditFormKey = '';

    itemCreateFormKey = '';

    @observable settingItemId?: ApplicationSettingItem['settingItemId'] =
        undefined;

    api: BasicStoreApi<ApplicationSettingItem> = {
        loadList: async () => {
            SettingsScoringModelStore.loadList();
            const list = await Promise.resolve(ListApplicationSettings);

            const filteredList = list?.filter((item) =>
                item.name
                    ?.toLowerCase()
                    ?.includes(
                        this.filterCriteria?.filter?.search
                            ?.trim()
                            ?.toLowerCase() || '',
                    ),
            );

            return filteredList || [];
        },
    };

    filterCriteria: FilterCriteria<SettingsPageFilter> = new FilterCriteria();

    @action setActiveSettingItemId(
        settingItemId: ApplicationSettingItem['settingItemId'],
    ) {
        this.settingItemId = settingItemId;
    }

    @computed get getActiveSettingItemId() {
        return this.settingItemId;
    }

    @computed get hasFilter() {
        const { search } = this.filterCriteria.filter;

        return !_.isNil(search);
    }
}

export const SettingsPageStore = new SettingsPageStoreClass();
